import { Outlet } from "react-router-dom";
import { UserPageContent } from "./styled";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { changeSidebarInOrders, changeSidebarWithNavigate } from "../../redux/slices/sidebar.slice";
import { changeActionbarType } from "../../redux/slices/actionbar.slice";
import { ActionbarType } from "../../redux/reducers/actionbar-reducers";
import { changePagination } from "../../redux/slices/recipients.slice";
import { OutletContext } from "../../router/router";

const UserPage = ({ context }: { context: OutletContext }) => {
    const { matchesPhone } = useAppSelector(state => state.deviceReducer);
    const { myRecipientsData } = useAppSelector(state => state.recipientDataReducer);

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(changeSidebarInOrders(false));
        dispatch(changeSidebarWithNavigate(true));
        dispatch(changeActionbarType(ActionbarType.USER_SETTINGS));
        dispatch(changePagination({ pageSize: myRecipientsData.pageSize, currentPage: 0 }));
    }, [])

    return (
        <UserPageContent style={{ padding: matchesPhone ? 0 : '0 2.5rem' }}>
            <Outlet context={context} />
        </UserPageContent>
    );
};

export default UserPage;



